/* cl-pdp.js — buybox do clone octipa-3 (vanilla; substitui media-gallery, variant-selects, product-form e os apps
   Moonbundle/Kiwi/Storyly do Sense dele). Kit = N linhas de variante -> /cart/add.js com as N unidades; a gaveta
   (cl-cart.js) aplica o codigo do kit. Classes do Sense podem vir renomeadas para clx-* (colisao com o Horizon). */
/* rw 11-01 (operador): o kit agora e o app Kaching REAL ([data-cl-app-slot="kaching"]): o ATC manda o lote
   do app (kaching-bundles-block.items(): unidades da barra, variante de cada peca, __kaching_bundles) em
   /cart/add.js?kaching_bundles=true; variante escolhida no widget -> foto/preco/URL. */
(function () {
  'use strict';
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function C(name) { return '.' + name + ', .clx-' + name; }
  function money(cents, fmt) {
    fmt = fmt || 'R$ {{amount_with_comma_separator}}';
    var v = (cents / 100).toFixed(2);
    var s = /comma_separator/.test(fmt) ? v.replace('.', ',') : v;
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }

  function init(host) {
    if (host.__cl) return; host.__cl = true;
    var root = host.querySelector('.cl-pdp') || host;
    var FMT = host.getAttribute('data-cl-money');
    var V = [];
    try { V = JSON.parse(root.querySelector('script[data-cl-variants]').textContent); } catch (e) {}
    var form = root.querySelector('form[data-cl-bundle]');

    /* ---------- galeria ---------- */
    var list = root.querySelector('[id^="Slider-Gallery"]');
    function items() { return list ? $$(list, '[data-media-id]') : []; }
    function show(mediaId) {
      if (!list) return;
      var hit = null;
      items().forEach(function (li) {
        var on = (li.getAttribute('data-media-id') || '').split('-').pop() === String(mediaId);
        li.classList.toggle('is-active', on); li.classList.toggle('clx-is-active', on);
        if (on) hit = li;
      });
      if (!hit) { var f = items().filter(function (li) { return li.offsetParent !== null || !li.classList.contains('cl-vhide'); })[0]; if (f) { f.classList.add('is-active'); hit = f; } }
      if (hit && window.innerWidth < 750) list.scrollTo({ left: hit.offsetLeft - list.offsetLeft, behavior: 'smooth' });
      $$(root, '[data-target]').forEach(function (t) {
        var b = t.querySelector('button');
        var on = (t.getAttribute('data-target') || '').split('-').pop() === String(mediaId);
        if (b) { if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }
      });
    }
    $$(root, '[data-target]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); show((t.getAttribute('data-target') || '').split('-').pop()); });
    });
    var V2M = {};
    try { V2M = JSON.parse(root.querySelector('script[data-cl-v2m]').textContent); } catch (e) {}
    function showVariantMedia(v) {
      if (!v) return;
      var fid = V2M[String(v.id)] || (v.featured_media && String(v.featured_media.id));
      if (!fid) return;
      $$(root, '[data-cl-vm]').forEach(function (el) { el.classList.toggle('cl-vhide', el.getAttribute('data-cl-vm') !== fid); });
      show(fid);
    }

    /* ---------- variante ---------- */
    function match(vals) {
      return V.filter(function (v) { return vals.every(function (val, i) { return v.options[i] === val; }); })[0];
    }
    function setVariant(v) {
      if (!v || !form) return;
      $$(form, 'input[name="id"]').forEach(function (i) { i.value = v.id; });
      var box = root.querySelector('[data-cl-price-box]');
      if (box) {
        var pr = box.firstElementChild;
        if (pr) {
          var sale = v.compare_at_price > v.price;
          ['price--on-sale', 'clx-price--on-sale'].forEach(function (c) { if (pr.className.indexOf(c.replace('--on-sale', '')) > -1) pr.classList.toggle(c, sale); });
          ['price--sold-out', 'clx-price--sold-out'].forEach(function (c) { if (pr.className.indexOf(c.replace('--sold-out', '')) > -1) pr.classList.toggle(c, !v.available); });
        }
        $$(box, '[data-cl-price]').forEach(function (e) { e.textContent = ' ' + money(v.price, FMT) + ' '; });
        $$(box, '[data-cl-compare]').forEach(function (e) { e.textContent = ' ' + money(v.compare_at_price || v.price, FMT) + ' '; });
      }
      var atc = root.querySelector('[data-cl-atc]'); if (atc) atc.disabled = !v.available;
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    /* seletor simples (packs, acessorios): selects data-cl-opt fora do kit */
    $$(root, 'select[data-cl-opt]').forEach(function (s) {
      if (s.closest(C('moonbundle-box').split(', ')[0]) || s.closest('.moonbundle-variant-row')) return;
      s.addEventListener('change', function () {
        var vals = $$(root, 'select[data-cl-opt]').filter(function (x) { return !x.closest('.moonbundle-variant-row'); }).map(function (x) { return x.value; });
        var v = match(vals); setVariant(v); showVariantMedia(v);
      });
    });

    /* ---------- app Kaching (slot do kit) ---------- */
    var slot = root.querySelector('[data-cl-app-slot="kaching"]');
    function kcBlock() { return slot && slot.querySelector('kaching-bundles-block'); }
    function kcItems() {
      var kb = kcBlock();
      if (kb && typeof kb.items === 'function') {
        try { var its = kb.items(); if (its && its.length) return its; } catch (er) {}
      }
      return null;
    }
    if (slot) {
      var kt = 0;
      var kcSync = function () {
        var its = kcItems(); if (!its) return;
        var v = V.filter(function (x) { return String(x.id) === String(its[0].id); })[0];
        if (v && form && (form.querySelector('input[name="id"]') || {}).value !== String(v.id)) { setVariant(v); showVariantMedia(v); }
      };
      var kcLater = function () { clearTimeout(kt); kt = setTimeout(kcSync, 60); };
      slot.addEventListener('change', kcLater);
      slot.addEventListener('click', kcLater);
    }

    /* ---------- kit (Moonbundle) ---------- */
    var wrappers = $$(root, '.moonbundle-option-wrapper');
    function activeWrap() { return wrappers.filter(function (w) { return w.querySelector('.moonbundle-option-active'); })[0] || null; }
    wrappers.forEach(function (w) {
      var opt = w.querySelector('.moonbundle-option'); if (!opt) return;
      opt.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        wrappers.forEach(function (x) {
          var o = x.querySelector('.moonbundle-option'), on = x === w;
          if (o) o.classList.toggle('moonbundle-option-active', on);
          var r = x.querySelector('input[type=radio]'); if (r) r.checked = on;
        });
        var row = w.querySelector('#moonbundle-variant-row-1');
        if (row) { var v = rowVariant(row); setVariant(v); }
      });
      opt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opt.click(); } });
    });
    function rowVariant(row) { return match($$(row, 'select[data-cl-opt]').map(function (s) { return s.value; })); }
    root.addEventListener('change', function (e) {
      var row = e.target.closest('.moonbundle-variant-row'); if (!row) return;
      var v = rowVariant(row);
      if (row.id === 'moonbundle-variant-row-1') { setVariant(v); showVariantMedia(v); }
      else if (form && v && !activeWrap()) setVariant(v);
    });

    /* ---------- ATC: N unidades do kit ativo (ou a variante + quantidade) ---------- */
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopPropagation();
      var kc = kcItems();
      if (kc) {
        var kb = { items: kc };
        var btn0 = form.querySelector('[type="submit"]'); if (btn0) btn0.setAttribute('aria-busy', 'true');
        var fin = function (res) {
          if (btn0) btn0.removeAttribute('aria-busy');
          var box0 = root.querySelector('.product-form__error-message-wrapper, .clx-product-form__error-message-wrapper');
          if (res && !res.ok && box0) {
            box0.hidden = false;
            var m0 = box0.querySelector('.product-form__error-message, .clx-product-form__error-message');
            if (m0) m0.textContent = (res.j && (res.j.description || res.j.message)) || 'Erreur';
            return;
          }
          document.dispatchEvent(new CustomEvent('cl:cart:open', { detail: { added: !!window.clCartPost } }));
        };
        var KURL = '/cart/add.js?kaching_bundles=true';
        if (window.clCartPost) window.clCartPost(KURL, kb).then(fin, function () { fin(null); });
        else fetch(KURL, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(kb) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(fin, function () { fin(null); });
        return;
      }
      var w = activeWrap(), items = {};
      var rows = w ? $$(w, '.moonbundle-variant-row') : [];
      if (rows.length) {
        rows.forEach(function (r) { var v = rowVariant(r); if (v) items[v.id] = (items[v.id] || 0) + 1; });
      } else {
        var qty = w ? +(w.getAttribute('data-cl-qty') || 1) : 1;
        var qi = document.querySelector('input[name="quantity"][form="' + form.getAttribute('id') + '"]');
        if (!w && qi) qty = Math.max(1, parseInt(qi.value || '1', 10));
        var id = (form.querySelector('input[name="id"]') || {}).value;
        if (id) items[id] = qty;
      }
      var payload = { items: Object.keys(items).map(function (k) { return { id: +k, quantity: items[k] }; }) };
      if (!payload.items.length) return;
      var btn = form.querySelector('[type="submit"]'); if (btn) btn.setAttribute('aria-busy', 'true');
      var done = function (res) {
        if (btn) btn.removeAttribute('aria-busy');
        var box = root.querySelector('.product-form__error-message-wrapper, .clx-product-form__error-message-wrapper');
        if (res && !res.ok && box) {
          box.hidden = false;
          var m = box.querySelector('.product-form__error-message, .clx-product-form__error-message');
          if (m) m.textContent = (res.j && (res.j.description || res.j.message)) || 'Erreur';
          return;
        }
        document.dispatchEvent(new CustomEvent('cl:cart:open', { detail: { added: !!window.clCartPost } }));
      };
      if (window.clCartPost) window.clCartPost('/cart/add.js', payload).then(done, function () { done(null); });
      else fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(done, function () { done(null); });
    }, true);

    /* ---------- quantidade (+/-) ---------- */
    $$(root, '.quantity, .clx-quantity').forEach(function (q) {
      var inp = q.querySelector('input[type="number"]'); if (!inp) return;
      $$(q, 'button[name="plus"], button[name="minus"]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var n = parseInt(inp.value || '1', 10) + (b.name === 'plus' ? 1 : -1);
          inp.value = Math.max(parseInt(inp.min || '1', 10), n);
        });
      });
    });

    /* ---------- faixa de servicos (auto 3 s + pontos + toque) ---------- */
    var sc = root.querySelector('#slider-content, .slider-content, .clx-slider-content');
    if (sc && sc.children.length > 1) {
      var n = sc.children.length, i = 0;
      var dots = $$(sc.parentNode, '.dot, .clx-dot');
      var go = function (k) {
        i = (k + n) % n; sc.style.transform = 'translateX(' + (-100 * i) + '%)';
        dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
      };
      dots.forEach(function (d, j) { d.removeAttribute('onclick'); d.addEventListener('click', function () { go(j); }); });
      var m0 = /translateX\((-?\d+)%\)/.exec(sc.style.transform || ''); go(m0 ? -(+m0[1]) / 100 : 0);
      setInterval(function () { go(i + 1); }, 3000);
      var x0 = null;
      sc.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      sc.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 30) go(i + (dx < 0 ? 1 : -1)); });
    }

    /* ---------- stories ---------- */
    var ov = root.querySelector('[data-cl-story-ov]');
    if (ov) {
      document.body.appendChild(ov);
      var vids = (ov.getAttribute('data-videos') || '').split(','), cur = 0, video = ov.querySelector('video');
      var play = function (k) { cur = (k + vids.length) % vids.length; video.src = vids[cur]; video.play().catch(function () {}); };
      $$(root, '[data-cl-story]').forEach(function (b) {
        b.addEventListener('click', function () { ov.classList.add('is-open'); document.documentElement.classList.add('cl-cart-open'); play(+b.getAttribute('data-cl-story')); });
      });
      var close = function () { ov.classList.remove('is-open'); video.pause(); document.documentElement.classList.remove('cl-cart-open'); };
      /* (classes x/p/n podem vir renomeadas para clx-* pela colisao com o Horizon) */
      var bx = ov.querySelector('.x, .clx-x'), bp = ov.querySelector('.p, .clx-p'), bn = ov.querySelector('.n, .clx-n');
      if (bx) bx.addEventListener('click', close);
      if (bp) bp.addEventListener('click', function () { play(cur - 1); });
      if (bn) bn.addEventListener('click', function () { play(cur + 1); });
      video.addEventListener('ended', function () { if (cur < vids.length - 1) play(cur + 1); else close(); });
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    }

    /* ---------- guia de tamanhos (Kiwi dele -> modal nosso) ---------- */
    var sg = host.querySelector('[data-cl-sg-modal]');
    if (sg) {
      document.body.appendChild(sg);
      var openSG = function (e) { if (e) e.preventDefault(); sg.hidden = false; sg.classList.add('is-open'); document.documentElement.classList.add('cl-sg-lock'); };
      var closeSG = function () { sg.classList.remove('is-open'); sg.hidden = true; document.documentElement.classList.remove('cl-sg-lock'); };
      $$(root, '[data-cl-size] button, .ks-chart-modal-button').forEach(function (b) { b.addEventListener('click', openSG); });
      $$(sg, '[data-cl-sg-close]').forEach(function (b) { b.addEventListener('click', closeSG); });
      sg.addEventListener('click', function (e) { if (e.target === sg) closeSG(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sg.classList.contains('is-open')) closeSG(); });
    }

    /* ---------- nota (link para as avaliacoes) ---------- */
    $$(root, 'a[href="#octipa-avis"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('octipa-avis') || document.querySelector('[id*="octipa_avis"], [id*="octipa-avis"]');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  function boot() { $$(document, '[data-cl-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
